import { Component } from '@angular/core'
import { setLayerControlsVisible } from '../shared/utils/layer-controls-utils'
import { Store } from '@ngrx/store'
import {
    selectCaseSegObjectPropertyMap,
    selectLoadedSegObjectPropertyMaps,
    selectSelectionPanelVisible,
} from '../state/case/case.selectors'
import { Tabs } from '../shared/components/side-panel/side-panel.component'
import { selectionActions } from '../state/selection/selection.actions'
import { SelectionType } from '../state/selection/selection.state'
import { plotDataActions } from '../state/plot-data/plot-data.actions'
import { PlotAxis } from '../state/plot-data/plot-data.state'
import { caseActions } from '../state/case/case.actions'
import { combineLatest, take } from 'rxjs'

@Component({
    selector: 'app-case-viewer',
    templateUrl: './case-viewer.component.html',
    styleUrls: ['./case-viewer.component.scss'],
})
export class CaseViewerComponent {
    readonly selectionPanelVisible$ = this.store.select(selectSelectionPanelVisible)
    tabToDisplay = Tabs.GATING

    constructor(private readonly store: Store) {}

    layerControlsToggled(visible: boolean): void {
        setLayerControlsVisible(visible)
    }

    changeTab(event: string): void {
        const tab = Tabs[event as keyof typeof Tabs]
        if (tab === Tabs.GATING) {
            this.store.dispatch(selectionActions.setType({ selectionType: SelectionType.Free }))
        }
        if (tab === Tabs.HIERARCHICAL_GATING) {
            this.store.dispatch(
                selectionActions.setType({ selectionType: SelectionType.Hierarchical })
            )
        }
        if (tab === Tabs.AUTO_CELL_TYPE_DETECTION) {
            this.store.dispatch(
                selectionActions.setType({ selectionType: SelectionType.Unsupervised })
            )
        }
        if (tab === Tabs.PLOTTING) {
            this.ensureSingleIntensityMapForPlotting()
        }

        this.store.dispatch(
            plotDataActions.loadDataForAxis({
                marker: null,
                axis: PlotAxis.COLOR,
            })
        )

        this.tabToDisplay = tab
    }

    /** Plotting jobs use a single map; unload extras when entering the tab. */
    private ensureSingleIntensityMapForPlotting(): void {
        combineLatest([
            this.store.select(selectLoadedSegObjectPropertyMaps),
            this.store.select(selectCaseSegObjectPropertyMap),
        ])
            .pipe(take(1))
            .subscribe(([loadedMaps, primaryMap]) => {
                if (loadedMaps.length <= 1) return
                const keepId =
                    primaryMap && loadedMaps.some(map => map.id === primaryMap.id)
                        ? primaryMap.id
                        : loadedMaps[loadedMaps.length - 1].id
                for (const map of loadedMaps) {
                    if (map.id === keepId) continue
                    this.store.dispatch(
                        caseActions.toggleLoadedSegObjectPropertyMap({
                            segobjectpropertymap: map,
                        })
                    )
                }
            })
    }

    protected readonly Tabs = Tabs
}
